// TODO - объединить словари с LangSelector

export const availableLanguages = ['ru', 'en'] as const;

export type Language = typeof availableLanguages[number];

export const defaultLanguage = 'ru';

export const defaultLanguageIfAbsent = 'en';
